// src/components/inputs/BoolInput.js
import PropTypes from "prop-types";
import React from "react";
import { Switch } from "@material-tailwind/react";

const BoolInput = ({ label, value, onChange }) => {
  return (
    <div className="mb-4 flex items-center pl-3">
      <Switch
        checked={value}
        onChange={() => {
          onChange(!value);
        }}
        label={label}
      />
    </div>
  );
};

BoolInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

BoolInput.defaultProps = {
  value: false,
};

export default BoolInput;
